import { Box, Typography } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';
import { People } from '~/services/Http';

import { statusToString } from '../../../../helper';

import { useSxStyles } from './useStyles';

export interface Props {
  listItem: People.WorklistDto;
}

export const WorklistPanelSummary: React.FC<Props> = ({ listItem }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  const statusSxStyles = listItem.status && {
    ...sxStyles.status,
    ...(listItem.status === 'NEW' && sxStyles.statusNew),
    ...(listItem.status === 'IN_PROGRESS' && sxStyles.statusInProgress),
    ...(listItem.status === 'SKIPPED' && sxStyles.statusInProgress),
    ...(listItem.status === 'COMPLETED' && sxStyles.statusCompleted),
  };

  const dueDateSxStyles = {
    ...(moment(listItem.dueDate) > moment() &&
      moment(listItem.dueDate) < moment().add(1, 'week') &&
      sxStyles.dueDateSoon),
    ...(moment(listItem.dueDate) < moment() && sxStyles.dueDatePast),
  };

  return (
    <SummaryItem
      customSxStyles={{
        listItemRoot: sxStyles.listItemRoot,
        listItemTextPrimary: sxStyles.listItemTextPrimary,
      }}
      avatarProps={{
        alt: listItem.pertainingTo?.firstName,
        src: listItem.pertainingTo?.profilePic,
      }}
      primaryElement={
        <>
          <Box sx={sxStyles.flex}>
            <Box component="span" sx={sxStyles.title}>
              {listItem.template.title}
            </Box>
            {listItem.status && (
              <Box sx={sxStyles.flexCenter}>
                <Typography sx={statusSxStyles}>
                  {statusToString(listItem.status, t)}
                </Typography>
              </Box>
            )}
          </Box>
          <Typography
            component="div"
            color="text.secondary"
            sx={sxStyles.listItemTextEmployee}
            data-cy="employee"
          >
            <TooltippedTruncatedText>
              {`${listItem.pertainingTo?.firstName} ${listItem.pertainingTo?.lastName} `}
            </TooltippedTruncatedText>
          </Typography>
        </>
      }
      secondaryElement={
        <>
          {`${listItem.template.type?.value}`}
          {listItem.dueDate && (
            <>
              {`, `}
              <Box component="span" sx={dueDateSxStyles} data-id="date">
                {`${t('dueOn')} ${moment(listItem.dueDate).format('L')}`}
              </Box>
            </>
          )}
        </>
      }
    />
  );
};
